/**
 * The UI actions the email arche registers with the global Fias AI assistant.
 *
 * Kept out of MailboxPage so the definitions can be pinned against the
 * assistant endpoint's bounds (`ARCHE_AI_ACTION_LIMITS`) — an over-long
 * description is rejected by the strict turn schema and fails EVERY assistant
 * turn made from the mailbox, not just the ones that would use the action.
 */

import type { ArcheAIAction } from '@/components/fias-ai';

export const EMAIL_AI_ACTIONS: ArcheAIAction[] = [
  {
    id: 'show_email_list',
    description:
      'Show a dynamic, filtered list of the user’s emails IN the mailbox (it replaces the ' +
      'folder view so the user sees the WHOLE list, not a truncated preview). Give a short ' +
      '`label` and AT LEAST ONE narrowing filter: `query` (free text over sender/subject/body, ' +
      'optionally scoped by `searchFields`), fromAddress (resolve a name via ' +
      'email_lookup_contact first), unanswered (inbound mail not yet replied to), ' +
      'folderSystemRole, isRead, isStarred, hasAttachments, receivedAfter/receivedBefore (ISO). ' +
      'A filter with no narrowing criterion is REJECTED. When the criterion is a JUDGEMENT the ' +
      'filters cannot state (“sales pitches”, “looks like an invoice”, “anything important”), ' +
      'do NOT widen the filter to approximate it: narrow with email_search, read the ' +
      'candidates, and build the list by hand with email_list_add. ' +
      'After showing, archive/trash/mark the whole list with email_archive_list / ' +
      'email_trash_list / email_mark_list.',
    parameterSchema: {
      type: 'object',
      required: ['label'],
      additionalProperties: false,
      properties: {
        label: { type: 'string', maxLength: 120 },
        query: { type: 'string', maxLength: 300 },
        searchFields: {
          type: 'array',
          maxItems: 4,
          items: { type: 'string', enum: ['from', 'recipient', 'subject', 'body'] },
        },
        fromAddress: { type: 'string', maxLength: 320 },
        unanswered: { type: 'boolean' },
        folderSystemRole: {
          type: 'string',
          enum: ['inbox', 'sent', 'drafts', 'trash', 'spam', 'archive'],
        },
        isRead: { type: 'boolean' },
        isStarred: { type: 'boolean' },
        hasAttachments: { type: 'boolean' },
        receivedAfter: { type: 'string', maxLength: 40 },
        receivedBefore: { type: 'string', maxLength: 40 },
        accountId: { type: 'string', maxLength: 64 },
      },
    },
  },
  {
    id: 'clear_ai_list',
    description:
      'Clear the current AI Filtered list and return the mailbox to its normal folder view.',
    parameterSchema: { type: 'object', additionalProperties: false, properties: {} },
  },
];
